import React, { useState } from "react";
import { Accordion } from "../../../../common/commonComponents";
import { Card, CardBody, Col, Row } from "reactstrap";
import RadioButtons from "../../components/RadioButtons";
import { labelStyles } from "./index";

const waiveOffTypes = [
  { value: "YES", label: "Yes" },
  { value: "NO", label: "No" },
];

const BU_LIST = ["IC006", "DW005", "DW007", "CH012"]
const WaiveOffGST = ({ values = {}, setValues , isReadOnly= false, country, bu}) => {
  const [gstDetailsOpen, setGstDetailsOpen] = useState(false);
  
  const gstWaiveOffChangeHandler  =( value)=>{
     setValues((prev)=>({...prev, gstDetails:{
         ...prev?.gstDetails,
           isWaiveOffGST: value
     } }))
  }
 if(country && (country === "IND"||country === "INDIA")) return <div></div>
 if(!BU_LIST.includes(bu)) return  <div></div>
  return (
    <div>
      <Accordion
        isFormOpen={gstDetailsOpen}
        title={"GST waive off"}
        key={"Gst waive off"}
        isEditFormOpen={(open) => {
          if (open) {
            setGstDetailsOpen(true);
          }
          setGstDetailsOpen(false);
        }}
      >
        <Card className="gst-details-card">
          <CardBody>
            <>
              <Row style={{ padding: "10px" }}>
                <Col md="4" className="p-0">
                  <div style={labelStyles}>
                    Wave off GST – Foreign Remittance
                  </div>
                  <RadioButtons
                    options={waiveOffTypes}
                    value={values?.gstDetails?.isWaiveOffGST}
                    readOnly = {isReadOnly}
                    onChange={(val) => gstWaiveOffChangeHandler(val)}
                  />
                </Col>
              </Row>
            </>
          </CardBody>
        </Card>
      </Accordion>
    </div>
  );
};

export default WaiveOffGST;
